import React from 'react'
import { Link } from "react-router-dom";

export default function HaldiBook() {
  return (
    <>
    <section className="haldipage-book">
        <div className="container">
            <div className="row align-items-center">

                <div className="col-lg-6 col-md-6 wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                    <h3 className="heading">Book Your Exclusive Virtual Appointment</h3>
                    
                    <p>Our work is recognised by leading fashion and lifestyle platforms for its refined craftsmanship, modern detailing, and cultural depth-reflecting our commitment to elegant, timeless bridalwear that blends contemporary style with authentic Indian artistry.</p>

                    <Link to={"/contact"} className="default-btn red-default">book appointment</Link>
                </div>

                <div className="col-lg-6 col-md-6">
                    <img src="/image/book-appoint.webp" className="img-responsive" alt="book" loading="lazy"/>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
